// =====================================================
// S-2/S-3 — forced-2FA-enrolment gate signal.
//
// Lives in its own tiny pub/sub store (like session-store.js) so the framework-
// agnostic API client can flip it WITHOUT importing React. When the backend's
// TwoFactorEnforcementGuard blocks a privileged-role user who hasn't enabled
// 2FA, it returns a 403 with body `code === "two_factor_required"`; the API
// client detects that and calls `twoFactorGate.require()`. The mounted
// <TwoFactorRequiredGate> (inside AuthProvider) subscribes and renders a
// blocking enrolment overlay until the user enrols (then `.clear()`).
//
// Default state is `false`, and `require()` is only ever reached when the
// backend enforcement flag is ON — so with enforcement OFF (the default) this
// module is completely inert and there is zero behavior change.
// =====================================================

let required = false;
const listeners = new Set();

const emit = () => {
  for (const fn of listeners) {
    try {
      fn(required);
    } catch {
      // a listener error must not break siblings
    }
  }
};

export const twoFactorGate = {
  get: () => required,

  require: () => {
    if (required) return; // already open — avoid redundant re-renders
    required = true;
    emit();
  },

  clear: () => {
    if (!required) return;
    required = false;
    emit();
  },

  subscribe: (fn) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};
